export enum MyTimePeriodEnum {
    TP36 = 36,
    TP48 = 48,
    TP60 = 60,
}
